module.exports = __webpack_public_path__ + "static/media/ORALPATHOLOGY_MDS.8bcfd586.docx";